<header>
    <div class="headerRow pad-lr clearfix">
      <div class="brandLogo">
        <img src="/assets/img/moglix-logo.jpg" width="120" />
      </div>
      <div class="mr-10">
        <form>
    
          <mat-form-field appearance="outline" class="mog3_matinput autocomplete-search">
            <input type="text" matInput [matAutocomplete]="brandAuto" placeholder="Brand Search"
              [formControl]="searchBrandControl">
            <i class="ri-search-line"></i>
            <mat-autocomplete class="autocomplete-menu" #brandAuto="matAutocomplete"
              (optionSelected)="onBrandFilterChange($event.option.value)">
              <mat-option *ngFor="let brand of filteredBrands" [value]="brand">
                {{ brand.brandName }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
     <!-- header.component.html -->
  <mat-form-field appearance="outline" class="mog3_matinput autocomplete-search">
    <input type="text" matInput [value]="searchOpenString" (input)="onOpenFilterChange($event.target.value)" 
      placeholder="Enter Keywords..." [formControl]="searchOpenControl">
    <i class="ri-search-line"></i>
  </mat-form-field>
  
  
  
          <button mat-icon-button type="submit" (click)="onSearchFilterChange($event)">
            <mat-icon>search</mat-icon>
          </button>
  
  
  
        </form>
      </div>
  
  
      <div class="topMenuBar">
        <ul class="topmenulist">
          <li class="userDetails">
            <div class="flagName">
              <img src="/assets/img/india.png" width="120" />
              <span>{{username}} {{countryName}}</span>
  
            </div>
  
          </li>
          <li class="logout" (click)="logout()">
            <span class="material-icons">logout</span>
          </li>
        </ul>
      </div>
  
    </div>
  </header>